import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { of, switchMap, catchError } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const userService = inject(UserService);

  // Check the authentication status
  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {

        // If the user is not authenticated...
        if (!authenticated) {
          // Redirect to the sign-in page with a redirectUrl param
          const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
          const urlTree = router.parseUrl(`auth/sign-in?${redirectURL}`);

          return of(urlTree);
        }

        const path = state.url.split('?')[0];
        if (
          userService.currentUser?.mustResetPassword &&
          !path.startsWith('/sign-out')
        ) {
          return of(router.parseUrl('/auth/reset-password?flow=temporary'));
        }

        // Allow the access
        return of(true);
      }),
      catchError((error) => {
        console.error('❌ AuthGuard error:', error);
        // On error, redirect to sign-in to be safe
        const urlTree = router.parseUrl('auth/sign-in');
        return of(urlTree);
      }),
    );
};
